import Alpine from 'alpinejs';

window.Alpine = Alpine;

document.addEventListener('alpine:init', () => {
	Alpine.data('taboolaDemo', () => ({
		url: '',
		isValid: false,

		init() {
			// Make the global variables accessible within the component
			this.taboola_demo_url = window.taboola_demo_url;
			this.taboola_demo_youtube_url = window.taboola_demo_youtube_url;

			// Watch for changes to url
			this.$watch('url', (value) => {
				this.isValid = this.validUrl(value);
			});
		},

		validUrl(str) {
			const regexp =
				/^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
			return regexp.test(str);
		},

		addProtocol(url) {
			if (!url.match(/^[a-zA-Z]+:\/\//)) {
				url = 'https://taboola.com';
			}
			return url;
		},

		setDemoUrl() {
			this.url = window.taboola_demo_url;
			this.isValid = this.validUrl(this.url);
			this.handleContinue();
		},

		setDemoYouTube() {
			this.url = window.taboola_demo_youtube_url;
			this.isValid = this.validUrl(this.url);
			this.handleContinue();
		},

		handleContinue() {
			const input = document.getElementById('demo-input');
			if (!this.isValid) {
				input?.classList.add('error');
				return false;
			}

			input?.classList.remove('error');

			// Check if we're on the French version of the site
			if (window.location.href.indexOf('/fr/') === -1) {
				window.location = `/demo-preview?url=${encodeURIComponent(
					this.addProtocol(this.url),
				)}`;
			} else {
				window.location = `/fr/demo-preview?url=${encodeURIComponent(
					this.addProtocol(this.url),
				)}`;
			}
			return false;
		},
	}));
});

Alpine.start();
